import { useContext } from 'react';

import UFOCustomData from '@atlaskit/react-ufo/custom-data';

import { CurrentDataContext } from 'src/app/current-data';
import { AppDataContext } from 'src/app/data';
import { uncurlyUuid } from 'src/components/analytics';

export const useBitbucketCustomData = () => {
  const { user } = useContext(AppDataContext);
  const { repository } = useContext(CurrentDataContext);

  const data: {
    repositoryId?: string;
    isAtlassian: boolean;
    isBitbucket: boolean;
  } = {
    isAtlassian: user?.isAtlassian ?? false,
    isBitbucket: user?.isBitbucket ?? false,
  };
  if (repository?.uuid) {
    data.repositoryId = uncurlyUuid(repository.uuid);
  }

  return data;
};

export const BitbucketCustomData = () => {
  const data = useBitbucketCustomData();

  return <UFOCustomData data={data} />;
};
